import { Button, List, notification, Spin, Typography } from 'antd';
import {
  useLazyGetOrgStructureOrganizationsQuery,
  useUpdateOrgStructureOrganizationsMutation,
} from 'app/services/edpApiV1/orgStructure';
import React, { useEffect, useState } from 'react';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import OrgstructireListItem from './components/OrgstructireListItem';
import style from './index.module.scss';

const OrgstructureSettings = () => {
  const [firstLoad, setFirstLoad] = useState<boolean>(false);
  const [getOrgstructure, { data, isLoading, isFetching }] = useLazyGetOrgStructureOrganizationsQuery();
  const [patchOrgstructure, { isLoading: isUpdateLoading }] = useUpdateOrgStructureOrganizationsMutation();
  const [loadingIds, setLoadingIds] = useState<string[]>([]);
  const [allLoading, setAllLoading] = useState<boolean>(false);

  useEffect(() => {
    setFirstLoad(true);
    getOrgstructure({}).then(() => {
      setFirstLoad(false);
    });
  }, []);

  const updateOrgstructure = async (id: string, isAvailable: boolean) => {
    setLoadingIds(data => [...data, id]);
    try {
      await patchOrgstructure({ id, isAvailable });
      await getOrgstructure({});
      notification.success({ message: isAvailable ? 'Организация добавлена' : 'Организация скрыта из оргструктуры' });
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Ошибка при изменении оргструктуры') });
    }

    setLoadingIds(data => data.filter(elem => elem !== id));
  };

  const pickAll = async () => {
    setAllLoading(true);
    try {
      await patchOrgstructure({ all: true, isAvailable: true });
      await getOrgstructure({});
      notification.success({ message: 'Организации выбраны' });
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Ошибка при выборе организаций') });
    }
    setLoadingIds([]);
    setAllLoading(false);
  };

  return (
    <>
      <div className={style.container}>
        <p className={style.title}>Выбор организаций, которые будут отображаться в организационной структуре</p>
        <Button type="primary" onClick={pickAll} loading={allLoading}>
          Выбрать все
        </Button>
      </div>
      <Spin spinning={firstLoad}>
        <List
          header={<div className={style.tableHeader}>Организация</div>}
          bordered
          dataSource={data}
          renderItem={({ isAvailable, name, id }) => (
            <List.Item>
              <OrgstructireListItem
                isAvailable={isAvailable}
                name={name}
                id={id}
                updateOrgstructure={updateOrgstructure}
                loading={((isUpdateLoading || isLoading || isFetching) && loadingIds.includes(id)) || allLoading}
                key={id}
              />
            </List.Item>
          )}
        />
      </Spin>
    </>
  );
};

export default OrgstructureSettings;
